import {
  CreateEmployeeFormData,
  CreateEmployeeRequest,
  EditEmployeeFormData,
  EditEmployeeRequest
} from "../../../Graphql/types/employee";
import { formatRequestDate } from "./dateUtils";

export const getCreateEmployeeRequest = (
  formData: CreateEmployeeFormData
): CreateEmployeeRequest => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    phoneNumber: formData.phoneNumber,
    role: formData.role,
    hiredEmployeeInfo: {
      avatar: formData.avatar,
      positions: formData.positions,
      positionLevel: formData.positionLevel,
      employmentType: formData.employmentType,
      employmentDuration: formData.employmentDuration,
      dateOfBirth: new Date(formData.dateOfBirth).toISOString().split("T")[0],
      hireDate: new Date(formData.hireDate).toISOString().split("T")[0],
      address: {
        country: formData.country,
        province: formData.province,
        district: formData.district,
        sector: formData.sector,
        cell: formData.cell,
        village: formData.village
      }
    }
  };
};

export const getEditEmployeeRequest = (
  formData: EditEmployeeFormData,
  id: string,
  isVerified: boolean
): EditEmployeeRequest => {
  return {
    id,
    firstName: formData.firstName,
    lastName: formData.lastName,
    phoneNumber: formData.phoneNumber,
    role: formData.role,
    hiredEmployeeInfo: {
      avatar: formData.avatar,
      positions: formData.positions,
      positionLevel: formData.positionLevel,
      employmentType: formData.employmentType,
      employmentDuration: formData.employmentDuration,
      dateOfBirth: formatRequestDate(formData.dateOfBirth) || "",
      hireDate: formatRequestDate(formData.hireDate) || "",
      rehireDate: formatRequestDate(formData.rehireDate),
      resignDate: formatRequestDate(formData.resignDate), // Optional
      resignReason: formData.resignReason, // Optional
      hireStatus: formData.hireStatus,
      isVerified,
      address: {
        country: formData.country,
        province: formData.province,
        district: formData.district,
        sector: formData.sector,
        cell: formData.cell,
        village: formData.village
      }
    }
  };
};
